import React from "react";
import Icon from "@/components/icons";
import { IconTypes } from "@/components/icons/types";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  EmailShareButton,
} from "react-share";
import { SocialLinkProps, SocialShareProps } from "./types";

const socialLinks: SocialLinkProps[] = [
  {
    source: "facebook",
    icon: "facebook-circle",
    sr: "Share this course on facebook",
    component: FacebookShareButton,
    url: "",
  },
  {
    source: "x",
    icon: "x",
    sr: "Share this course on X",
    component: TwitterShareButton,
    url: "",
  },
  {
    source: "linkedin",
    icon: "linkedin-circle",
    sr: "Share this course on linkedin",
    component: LinkedinShareButton,
    url: "",
  },
  {
    source: "email",
    icon: "mail",
    sr: "Share this course via email",
    component: EmailShareButton,
    url: "",
  },
];

export default function SocialShare({
  productUrl,
  productName,
  className = "",
  shortcodeData = null,
  title = "Share this course",
}: SocialShareProps) {
  /**
   * @deprecated This function is deprecated and will be removed in a future version.
   * Use the new social sharing implementation instead.
   */
  const getShareLinkWithUtmParams = (source: string, url?: string) => {
    const shareUrl = url ?? productUrl;
    if (!source || !shareUrl) {
      return "";
    }

    const campaign = "social-sharing-course-page";
    const medium = "social";
    return `${shareUrl}?utm_campaign=${campaign}&utm_medium=${medium}&utm_source=${source}`;
  };

  // Use shortcode data if available, otherwise use default links
  const links = shortcodeData?.socialLinks || socialLinks;
  return (
    <div
      className={`${
        shortcodeData?.socialLinks && shortcodeData?.socialLinks.length > 0
          ? "fullwidth"
          : "w-full mx-auto"
      } ${
        shortcodeData?.bgColor === "white" ? "md:bg-white" : "bg-putty-100"
      } md:py-6 ${className}`}
    >
      <h2 className="text-2xl md:text-3xl text-center mt-0 mb-4">
        {shortcodeData?.title ?? title}
      </h2>
      <div className="mb-4 justify-center flex flex-row">
        {links.map((socialLink, index) => {
          const ShareComponent = socialLink.component;
          const url =
            socialLink.url && socialLink.url.length
              ? socialLink.url
              : productUrl
                ? getShareLinkWithUtmParams(socialLink.source)
                : "";

          return (
            <div key={index} className="mx-2 flex flex-col gap-2">
              <ShareComponent
                url={url}
                {...(socialLink.title && { title: socialLink.title })}
                {...(socialLink.subject && { subject: socialLink.subject })}
                {...(!socialLink.title &&
                  socialLink.source === "x" && { title: productName })}
                {...(!socialLink.subject &&
                  socialLink.source === "email" && { subject: productName })}
              >
                <div className="flex bg-primary text-white border border-solid border-primary h-12 w-12 items-center justify-center rounded-full">
                  <Icon type={socialLink.icon as IconTypes} />
                  <span className="sr-only">{socialLink.sr}</span>
                </div>
              </ShareComponent>
            </div>
          );
        })}
      </div>
    </div>
  );
}
